<template>
	<div id="switch-trip">
		<div class="buisness-travel df-jsb-aic mt2">
			<h3 class="raleway-semi-p13 mb-0">Club Hortense</h3>
			<input type="checkbox" id="free_cancel" v-model="selected" /><label for="free_cancel">free_cancel</label>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'switch-trip',
		data() {
			return {
				selected: false,
			};
		},
		watch: {
			selected(val) {
				this.$emit('checked', val, 'freeCancel');
			},
		},
	};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter"></style>
